import { AppAreaConfig, DomainConfig } from '@/funnels/@types'
import merge from 'lodash.merge'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const female: AppAreaConfig = {
	appArea: 'female',
	landing: {
		ids: ['loader-f'],
		route: {
			path: '/f',
			name: 'female-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'female_funnel', // /f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female'],
			},
			{
				matcher: {
					utm_term: /bellytype/,
				},
				ids: ['creatives-bellytype'],
			},
			{
				matcher: {
					$or: {
						utm_content: /excel/,
						utm_term: /excel/,
					},
				},
				ids: ['creatives-spreadsheet'],
			},
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female'],
			},
		],
	},
	funnel: {
		id: 'ob-female-funnel',
		route: {
			path: '/f/ob/:page*',
			name: 'female-survey',
		},
		slug: 'female',
		theme: 'light',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ar',
			'ja',
		],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f',
		routeNamesCrm: ['plan-email-female', 'plan-email-female-commitment'],
		overrides: [
			{
				matcher: { plans_type: 'short' },
				routeName: 'plan-email-female', // Temporary solution for UA team
			},
			{
				matcher: { plans_type: 'commitment' },
				routeName: 'plan-f-commitment',
			},
			{
				matcher: { plans_type: 'shortfree' },
				routeName: 'plan-f-free',
			},
			{
				matcher: { country: 'us' },
				routeName: 'plan-f-us',
			},
			{
				matcher: { country: 'br' },
				routeName: 'plan-f-br',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
		overrides: [
			{
				matcher: { country: 'us' },
				routeNames: ['upsell-static-subscription-activated', 'upsell-f', 'upsell-upgrade-f'],
			},
		],
	},
	upgrade: {
		routeName: null,
	},
}

const male: AppAreaConfig = {
	appArea: 'male',
	landing: {
		ids: ['loader-m'],
		route: {
			path: '/m',
			name: 'male-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'male_funnel', // /m?safe&lptype=male_funnel&lpid=
				},
				ids: ['dynamic-loader-male-dark'],
			},
		],
	},
	funnel: {
		id: 'ob-male-funnel',
		route: {
			path: '/m/ob/:page*',
			name: 'male-survey',
		},
		slug: 'male',
		theme: 'navy',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ar',
			'ja',
		],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-m',
		routeNamesCrm: ['plan-email'],
		overrides: [
			{
				matcher: { plans_type: 'shortfree' },
				routeName: 'plan-m-free',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-m-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
	upgrade: {
		routeName: null,
	},
}

const main: AppAreaConfig = {
	appArea: 'main',
	landing: {
		ids: ['loader-main'],
		route: null, // this route defined in router/index.js
		overrides: [
			{
				matcher: {
					lptype: 'age_selection', // /?safe&lptype=age_selection&lpid=
				},
				ids: ['dynamic-age-18-50'],
			},
			{
				matcher: {
					lptype: 'main_loader', // /?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader'],
			},
			{
				matcher: {
					$or: {
						utm_content: /excel/,
						utm_term: /excel/,
					},
				},
				ids: ['creatives-spreadsheet'],
			},
			{
				matcher: {
					$and: {
						utm_content: /calorie|calculator/,
						utm_campaign: /search/,
					},
				},
				ids: ['creatives-calorie-calculator'],
			},
			{
				matcher: {
					$and: {
						utm_content: /kw_weightloss/,
						utm_source: /google/,
					},
				},
				ids: ['creatives-weight-loss'],
			},
			{
				matcher: {
					$and: {
						utm_content: /kw_fasting/,
						utm_source: /google/,
					},
				},
				ids: ['creatives-fasting'],
			},
			{
				matcher: {
					$and: {
						utm_content: /kw_diet/,
						utm_source: /google/,
					},
				},
				ids: ['creatives-best-diet'],
			},
		],
	},
	funnel: {
		id: 'ob-universal-funnel',
		route: {
			path: '/main/ob/:page*',
			name: 'survey',
		},
		slug: 'main',
		theme: 'light',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ja',
			'ar',
		],
		redirectTo: {
			sex: {
				male: { appArea: male },
				female: { appArea: female },
			},
		},
	},
}

const assessment: AppAreaConfig = {
	appArea: 'assessment',
	landing: {
		route: null,
	},
	funnel: {
		id: 'crm_assessment',
		slug: 'crm_assessment',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-email',
		routeNamesCrm: ['plan-email'],
	},
	upsell: {
		routeNames: ['upsell-static-assessment-result', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const workbooks: AppAreaConfig = {
	appArea: 'workbooks',
	landing: {
		route: null,
	},
	funnel: {
		id: 'crm_workbooks',
		slug: 'crm_workbooks',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-email',
		routeNamesCrm: ['plan-email'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleMediterraneanDiet: AppAreaConfig = {
	appArea: 'female-mediterranean-diet',
	landing: {
		ids: ['loader-f-mediterranean-diet'],
		route: {
			path: '/mediterranean-diet-f',
			name: 'female-mediterranean-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-funnel-mediterranean-diet',
		route: {
			path: '/mediterranean-diet-f/ob/:page*',
			name: 'female-mediterranean-diet-onboarding',
		},
		slug: 'female-mediterranean-diet',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: female,
				page: 'target-zones',
			},
		},
	},
}

const femaleKetoDiet: AppAreaConfig = {
	appArea: 'female-keto-diet',
	landing: {
		ids: ['loader-f-keto-diet'],
		route: {
			path: '/keto-diet-f',
			name: 'female-keto-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-keto-diet-female',
		route: {
			path: '/keto-diet-f/ob/:page*',
			name: 'female-keto-diet-onboarding',
		},
		slug: 'female-keto-diet',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: female,
				page: 'target-zones',
			},
		},
	},
}

const femaleCortisolDiet: AppAreaConfig = {
	appArea: 'female-cortisol-diet',
	landing: {
		ids: ['loader-f-cortisol-diet'],
		route: {
			path: '/cortisol-diet-f',
			name: 'female-cortisol-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-cortisol-diet',
		route: {
			path: '/cortisol-diet-f/ob/:page*',
			name: 'female-cortisol-diet-onboarding',
		},
		slug: 'female-cortisol-diet',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-cortisol-f',
		routeNamesCrm: ['plan-email-cortisol-f'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleMenopauseDiet: AppAreaConfig = {
	appArea: 'female-menopause-diet',
	options: {
		userTags: ['menopause'],
	},
	landing: {
		ids: ['loader-f-menopause-diet', 'age-menopause-f'],
		route: {
			path: '/menopause-diet-f',
			name: 'female-menopause-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-menopause-diet',
		route: {
			path: '/menopause-diet-f/ob/:page*',
			name: 'female-menopause-diet-onboarding',
		},
		slug: 'female-menopause-diet',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-menopause-f',
		routeNamesCrm: ['plan-email-menopause-female'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const inviteeShortFunnel: AppAreaConfig = {
	appArea: 'together',
	landing: {
		ids: ['loader-main'],
		route: {
			path: '/together',
			name: 'together-funnel',
		},
	},
	funnel: {
		id: 'ob-subscription-share-invitee-signup',
		route: {
			path: '/together/ob/:page*',
			name: 'together-onboarding',
		},
		slug: 'together',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-main',
		routeNamesCrm: ['plan-email'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const callFunnel: AppAreaConfig = {
	appArea: 'call',
	landing: {
		ids: ['loader-main'],
		route: {
			path: '/call',
			name: 'call-funnel',
		},
	},
	funnel: {
		id: 'ob-call-funnel',
		route: {
			path: '/call/ob/:page*',
			name: 'call-onboarding',
		},
		slug: 'call',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-main',
		routeNamesCrm: ['plan-email'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const maleCarnivore: AppAreaConfig = {
	appArea: 'male-carnivore-diet',
	landing: {
		ids: ['loader-m-carnivore-diet'],
		route: {
			path: '/carnivore-diet-m',
			name: 'male-carnivore-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-male-funnel-carnivore',
		route: {
			path: '/carnivore-diet-m/ob/:page*',
			name: 'male-carnivore-diet-onboarding',
		},
		slug: 'male-carnivore-diet',
		theme: 'navy',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: male,
				page: 'belly-type',
			},
		},
	},
}

const femaleBarre: AppAreaConfig = {
	appArea: 'female-barre',
	landing: {
		ids: ['loader-f-barre', 'age-barre-f'],
		route: {
			path: '/barre-f',
			name: 'female-barre-funnel',
		},
	},
	funnel: {
		id: 'ob-female-barre',
		route: {
			path: '/barre-f/ob/:page*',
			name: 'female-barre-onboarding',
		},
		slug: 'female-barre',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-barre-f',
		routeNamesCrm: ['plan-email-barre-f'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleGlp: AppAreaConfig = {
	appArea: 'female-glp',
	options: {
		userTags: ['glp'],
	},
	landing: {
		ids: ['loader-f-glp'],
		route: {
			path: '/glp-f',
			name: 'female-glp-funnel',
		},
	},
	funnel: {
		id: 'ob-female-glp',
		route: {
			path: '/glp-f/ob/:page*',
			name: 'female-glp-onboarding',
		},
		slug: 'female-glp',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-glp-f',
		routeNamesCrm: ['plan-email-glp-f'],
	},
	upsell: { routeNames: ['upsell-static-subscription-activated', 'upsell-f', 'upsell-upgrade-f'] },
	upgrade: { routeName: null },
}

const femaleFunnelAl: AppAreaConfig = {
	appArea: 'female-al',
	landing: {
		ids: ['loader-f'],
		route: {
			path: '/f-al',
			name: 'female-funnel',
		},
	},
	funnel: {
		id: 'ob-female-funnel-al',
		route: {
			path: '/f-al/ob/:page*',
			name: 'female-al-survey',
		},
		slug: 'female-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f-al',
		routeNamesCrm: ['plan-email-female'],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f', 'upsell-upgrade-f-al'],
	},
	upgrade: {
		routeName: null,
	},
}

const femaleWaterBalance: AppAreaConfig = {
	appArea: 'female-water-balance',
	landing: {
		ids: ['loader-water-balance-f'],
		route: {
			path: '/water-balance-f',
			name: 'female-water-balance-funnel',
		},
	},
	funnel: {
		id: 'ob-water-balance-female',
		route: {
			path: '/water-balance-f/ob/:page*',
			name: 'water-balance-female-onboarding',
		},
		slug: 'female-water-balance',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: female,
				page: 'lifestyle',
			},
		},
	},
}

export const bauWildcard: DomainConfig = {
	'/': merge<{}, AppAreaConfig, Partial<AppAreaConfig>>({}, main, { appArea: 'wildcard-main' }),
	'/f': merge<{}, AppAreaConfig, Partial<AppAreaConfig>>({}, female, { appArea: 'wildcard-female' }),
	'/m': merge<{}, AppAreaConfig, Partial<AppAreaConfig>>({}, male, { appArea: 'wildcard-male' }),
}

const config: DomainConfig = {
	'/': main,
	'/f': female,
	'/f-al': femaleFunnelAl,
	'/m': male,
	'/assessment': assessment,
	'/workbooks': workbooks,
	'/mediterranean-diet-f': femaleMediterraneanDiet,
	'/keto-diet-f': femaleKetoDiet,
	'/cortisol-diet-f': femaleCortisolDiet,
	'/menopause-diet-f': femaleMenopauseDiet,
	'/together': inviteeShortFunnel,
	'/call': callFunnel,
	'/carnivore-diet-m': maleCarnivore,
	'/barre-f': femaleBarre,
	'/glp-f': femaleGlp,
	'/water-balance-f': femaleWaterBalance,
}

export default config
